module.exports = __webpack_public_path__ + "assets/img/title-1e6ca997.png";